import { __assign } from "tslib";
// DS: I125
// from GDrive
import React from 'react';
import IconWrap from '../../IconWrap';
var CommentOutline = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("path", { fillRule: "evenodd", d: "M14 1a1 1 0 01.993.883L15 2v7.086a1 1 0 01-.206.608l-.087.099-1.914 1.914a1 1 0 01-.576.284l-.131.009H9l-1.703 2.555a1 1 0 01-.708.437L6.465 15H6a1 1 0 01-.993-.883L5 14v-2H2a1 1 0 01-.993-.883L1 11V3.914a1 1 0 01.206-.608l.087-.099 1.914-1.914a1 1 0 01.576-.284L3.914 1H14zm0 1H3.914L2 3.914V11h4v3h.465l2-3h3.62L14 9.086V2z" }))));
};
CommentOutline.displayName = 'CommentOutline';
export default CommentOutline;
//# sourceMappingURL=CommentOutline.js.map